export default __webpack_public_path__ + "static/media/BI_Dashboard_icon.a9f7f447.png";